export default function fetchPrice(unitPrice) {
  if (unitPrice !== undefined && unitPrice !== "") {
    return (unitPrice).toFixed(2);
  }
};